
<!-- 
VisitReplyModal.vue
功能：排訪結果回報視窗
作者：i9400538 陳博承
完成：2022-06-27
-->
<template>
  <div class="modal fade" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')">
            <i class="icon-close"></i>
          </a>
          <span v-if="action=='1'" class="title-use">
            <label>要保人</label>
            <label class="text-red text-underline">{{apc_name}}</label>拜訪結果
          </span>
          <span v-if="action=='2' && visit_reply=='1'" class="title-use">
            <label>要保人</label>
            <label class="text-red text-underline">{{apc_name}}</label>於尚未申辦轉帳/信用卡扣款前的繳費方式
          </span>
          <span v-if="action=='2' && visit_reply=='2'" class="title-use">
            <label>要保人</label>
            <label class="text-red text-underline">{{apc_name}}</label>未確認繳費意願及繳費管道原因
          </span>
        </div>
        <!-- action:1 保戶拜訪結果 -->
        <!-- 初始區塊 -->
        <div v-if="action == '1'" class="min-h">
          <div>
            <div class="radio radio-inline">
              <input
                type="radio"
                value="1"
                id="visit_reply_r1"
                v-model="visit_reply"
                data-vv-as="業務員確認完成"
              />
              <label for="visit_reply_r1">業務員確認完成</label>
            </div>
            <br />
            <div class="radio radio-inline">
              <input
                type="radio"
                value="2"
                id="visit_reply_r2"
                v-model="visit_reply"
                data-vv-as="未確認繳費意願及繳費管道"
              />
              <label for="visit_reply_r2">未確認繳費意願及繳費管道</label>
            </div>
          </div>
          <br />
          <div class="text-center">
            <button type="button" class="btn btn-primary" @click="$emit('close')">取消</button>
            <button v-if="visit_reply" type="button" class="btn btn-primary" @click="doNextStep">下一步</button>
            <button v-else type="button" class="btn btn-primary" disabled="true">下一步</button>
          </div>
        </div>
        <!-- action:2 業務員確認完成 block -->
        <div v-if="action == '2' && visit_reply=='1'" class="min-h">
          <div>
            <div class="radio radio-inline">
              <input
                type="radio"
                value="Z"
                id="pay_way_code_r1"
                v-model="pay_way_code"
                data-vv-as="無繳費意願"
              />
              <label for="pay_way_code_r1">無繳費意願</label>
            </div>
            <br />
            <div class="radio radio-inline">
              <input
                type="radio"
                value="6"
                id="pay_way_code_r2"
                v-model="pay_way_code"
                data-vv-as="自行繳費：由本公司寄發繳款單方便您隨時至金融機構、郵局、超商、ATM或線上完成繳費"
              />
              <label for="pay_way_code_r2">自行繳費：由本公司寄發繳款單方便您隨時至金融機構、郵局、超商、ATM或線上完成繳費</label>
            </div>
            <br />
            <div class="radio radio-inline">
              <input
                type="radio"
                value="1"
                id="pay_way_code_r3"
                v-model="pay_way_code"
                data-vv-as="派員收費：由本公司派員與您約定時間地點收取保費"
              />
              <label for="pay_way_code_r3">派員收費：由本公司派員與您約定時間地點收取保費</label>
            </div>
            <br />
            <br />
            <label>※回報繳費方式後，請至金控入口網/系統專區/業務作業/表單整合平台(無條碼)/業務分類：保費/保戶關懷及繳費方式確認書列印並簽寫確認書，交由服務中心掃描上傳</label>
            <br />
            <label>※公司另提供轉帳/信用卡授權扣款服務，可另行協助保戶辦理</label>
          </div>
          <br />
          <div class="text-center">
            <button type="button" class="btn btn-primary" @click="doPreStep">上一步</button>
            <button
              v-if="pay_way_code"
              type="button"
              class="btn btn-primary"
              @click="$emit('submit',chk_status, pay_way_code)"
            >提交</button>
            <button v-else type="button" class="btn btn-primary" disabled="true">提交</button>
          </div>
        </div>
        <!-- action:2 未確認繳費意願及繳費管道 block -->
        <div v-if="action == '2' && visit_reply=='2'" class="min-h">
          <div>
            <div class="radio radio-inline">
              <input
                type="radio"
                value="02"
                id="chk_status_r1"
                v-model="chk_status"
                data-vv-as="拒簽"
              />
              <label for="chk_status_r1">拒簽</label>
            </div>
            <br />
            <div class="radio radio-inline">
              <input
                type="radio"
                value="03"
                id="chk_status_r2"
                v-model="chk_status"
                data-vv-as="考慮中"
              />
              <label for="chk_status_r2">考慮中</label>
            </div>
            <br />
            <div class="radio radio-inline">
              <input
                type="radio"
                value="04"
                id="chk_status_r3"
                v-model="chk_status"
                data-vv-as="因故無法受訪"
              />
              <label for="chk_status_r3">因故無法受訪</label>
            </div>
            <br />
            <div class="radio radio-inline">
              <input
                type="radio"
                value="05"
                id="chk_status_r4"
                v-model="chk_status"
                data-vv-as="身故/癱瘓/聾啞或其他失能疾患致無法接電話"
              />
              <label for="chk_status_r4">身故/癱瘓/聾啞或其他失能疾患致無法接電話</label>
            </div>
            <br />
            <div class="radio radio-inline">
              <input
                type="radio"
                value="06"
                id="chk_status_r5"
                v-model="chk_status"
                data-vv-as="親訪(地址錯誤)"
              />
              <label for="chk_status_r5">親訪(地址錯誤)</label>
            </div>
            <br />
            <div class="radio radio-inline">
              <input
                type="radio"
                value="07"
                id="chk_status_r6"
                v-model="chk_status"
                data-vv-as="親訪(無人回應，無法判斷地址正確性)"
              />
              <label for="chk_status_r6">親訪(無人回應，無法判斷地址正確性)</label>
            </div>
            <br />
            <div class="radio radio-inline">
              <input
                type="radio"
                value="08"
                id="chk_status_r7"
                v-model="chk_status"
                data-vv-as="親訪(無法遇本人但地址正確)"
              />
              <label for="chk_status_r7">親訪(無法遇本人但地址正確)</label>
            </div>
            <br />
            <div class="radio radio-inline">
              <input
                type="radio"
                value="09"
                id="chk_status_r8"
                v-model="chk_status"
                data-vv-as="親訪(非居住地址，如國外工作)"
              />
              <label for="chk_status_r8">親訪(非居住地址，如國外工作)</label>
            </div>
            <br />
            <div class="radio radio-inline">
              <input
                type="radio"
                value="11"
                id="chk_status_r9"
                v-model="chk_status"
                data-vv-as="無法聯繫本人"
              />
              <label for="chk_status_r9">無法聯繫本人</label>
            </div>
          </div>
          <br />
          <div class="text-center">
            <button type="button" class="btn btn-primary" @click="doPreStep">上一步</button>
            <button
              v-if="chk_status"
              type="button"
              class="btn btn-primary"
              @click="$emit('submit',chk_status,pay_way_code)"
            >提交</button>
            <button v-else type="button" class="btn btn-primary" disabled="true">提交</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { commonMixin } from "@/mixins/common";
export default {
  name: "VisitReplyModal",
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    apc_name: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      action: "1",
      visit_reply: "", //保戶拜訪結果
      pay_way_code: "", //繳費方式(1=人員收費,6=自行繳費,Z=無繳費意願)
      chk_status: "" //確認進度(02=拒簽,03=考慮中,04=因故無法受訪,05=身故/癱瘓/聾啞或其他失能疾患致無法接電話,06=親訪(地址錯誤),07=親訪(無人回應，無法判斷地址正確性),08=親訪(無法遇本人但地址正確),09=親訪(非居住地址，如國外工作),11=無法聯繫本人,99=業務員確認完成)
    };
  },
  watch: {
    open: function() {
      this.init();
    }
  },
  methods: {
    //初始化
    init() {
      this.action = "1";
      this.visit_reply = "";
      this.chk_status = "";
      this.pay_way_code = "";
    },
    //上一步
    doPreStep() {
      this.action = "1";
      this.chk_status = "";
      this.pay_way_code = "";
    },
    //下一步
    doNextStep() {
      this.action = "2";
      if (this.visit_reply == "1") {
        this.chk_status = "99"; //業務員確認完成
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.padding-left-use {
  padding-left: 1.5rem;
}
.text-center {
  text-align: center;
}
.min-h {
  padding: 20px 40px;
  min-height: 190px;
  line-height: 1.5;
  position: relative;
  -webkit-box-flex: 1;
  flex: 1 1 auto;
}
.btn-cancel {
  color: #fff;
  border: 1px solid #c66f1c;
  border-radius: 4px;
  box-shadow: none !important;
  border-color: transparent !important;
  background: #c2c4c7 !important;
  display: inline-block;
  padding: 11px 19px;
  margin: 5px;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
}
.title-use {
  font-size: 24px;
  font-weight: 600;
  line-height: 1.5;
  margin: 0 auto 0 0;
}
</style>